import { buildSelector } from '@/shared/lib/store';
import type { StateStatus } from '@/shared/types/store';

export const [useViewerDataStatus] = buildSelector(
    (state) => state.viewer?.status,
);

export const [useCurrentViewerDataStatus] = buildSelector(
    (state, currentStatus: StateStatus) =>
        state.viewer?.status === currentStatus,
);
